module.exports = __webpack_public_path__ + "static/media/server2.8bb4e3ae.jpg";